export default function getResource(label, vars = []) {
    const resources = { startAReturn: 'Start a return' };

    return resources[label];
}
